<template>
  <div>
    <Header class="yh-header" active="/service/yxzt" showSub :subMenu="subMenu" />
    <div style="height: 130px"></div>
    <el-container class="container">
      <el-main class="fwxs">
        <div class="select">
          <span class="select-year">请选择年份</span>
          <el-date-picker
            class="year"
            v-model="year"
            format="yyyy"
            value-format="yyyy"
            type="year"
            placeholder="选择年"
          ></el-date-picker>
          <el-button type="primary" @click="onYearChange">查询</el-button>
        </div>
        <ProductServiceSolarTermSelect :active="month" @change="onMonthChange" />

        <MarketingPage @change="onPageChange" />
      </el-main>
    </el-container>
  </div>
</template>

<script>
import Header from "@/components/Header";

import CommodityMarketingAside from "@/components/CommodityMarketingAside";

import ProductServiceMonthSelect from "@/components/ProductServiceMonthSelect";
import ProductServiceSolarTermSelect from "@/components/ProductServiceSolarTermSelect";

import ProductServiceDiscuss from "@/components/ProductServiceDiscuss";

import MarketingPage from "@/components/MarketingPage";

export default {
  name: "ProductHome",
  components: {
    Header,
    CommodityMarketingAside,

    ProductServiceMonthSelect,
    ProductServiceSolarTermSelect,
    ProductServiceDiscuss,

    MarketingPage
  },
  data() {
    console.log(this.getSolarTerm());
    return {
      subMenu: [
        { name: "24节气", path: "/service/fwxs", active: true },
        { name: "营销主题", path: "/service/yxzt", active: false }
      ],
      year: "2019",
      month: this.getSolarTerm()
    };
  },
  created() {
    this.$store.dispatch("commodityMarketingPage", {
      packageName: "marketing",
      className: "commodityMarketing",
      methodName: "retrieve",
      params: {
        type: "风物鲜赏",
        month: this.month,
        numPerPage: 5
      }
    });

    this.ajax.doPost({
      packageName: "user",
      className: "userAnalysis",
      methodName: "create",
      params: {
        userId: this.$store.state.sys.sysUser.me.id,
        moduleName: "商品营销-风物鲜赏",
        moduleResourceId: this.$route.params.id,
        path: this.$route.path
      }
    });
  },
  methods: {
    onYearChange() {
      this.$store.dispatch("commodityMarketingPage", {
        packageName: "marketing",
        className: "commodityMarketing",
        methodName: "retrieve",
        params: {
          type: "风物鲜赏",
          year: this.year,
          numPerPage: 5
        }
      });
    },
    onMonthChange(e) {
      this.month = e;

      this.$store.dispatch("commodityMarketingPage", {
        packageName: "marketing",
        className: "commodityMarketing",
        methodName: "retrieve",
        params: {
          type: "风物鲜赏",
          month: e,
          numPerPage: 5
        }
      });
    },
    onPageChange(e) {
      this.$store.dispatch("commodityMarketingPage", {
        packageName: "marketing",
        className: "commodityMarketing",
        methodName: "retrieve",
        params: {
          type: "风物鲜赏",
          pageNum: e,
          month: this.month,
          numPerPage: 5
        }
      });
    },
    getSolarTerm() {
      const date = new Date();
      let yyyy = date.getFullYear();
      let mm = date.getMonth();
      let dd = date.getDate();
      var sTermInfo = new Array(
        0,
        21208,
        42467,
        63836,
        85337,
        107014,
        128867,
        150921,
        173149,
        195551,
        218072,
        240693,
        263343,
        285989,
        308563,
        331033,
        353350,
        375494,
        397447,
        419210,
        440795,
        462224,
        483532,
        504758
      );
      var solarTerm = new Array(
        23,
        24,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22
      );
      var solarTerms = "";
      while (solarTerms == "") {
        var tmp1 = new Date(
          31556925974.7 * (yyyy - 1900) +
            sTermInfo[mm * 2 + 1] * 60000 +
            Date.UTC(1900, 0, 6, 2, 5)
        );
        var tmp2 = tmp1.getUTCDate();
        if (tmp2 == dd) solarTerms = solarTerm[mm * 2 + 1];
        tmp1 = new Date(
          31556925974.7 * (yyyy - 1900) +
            sTermInfo[mm * 2] * 60000 +
            Date.UTC(1900, 0, 6, 2, 5)
        );
        tmp2 = tmp1.getUTCDate();
        if (tmp2 == dd) solarTerms = solarTerm[mm * 2];
        if (dd > 1) {
          dd = dd - 1;
        } else {
          mm = mm - 1;
          if (mm < 0) {
            yyyy = yyyy - 1;
            mm = 11;
          }
          dd = 31;
        }
      }
      return solarTerms;
    }
  }
};
</script>

<style lang="less">
.fwxs {
  .select {
    .select-year {
      color: #333;
    }

    .year {
      margin: 0 10px;
    }

    .el-input__inner {
      // height: 30px;
    }

    .el-button {
    }
  }
}
</style>


<style lang="less" scoped>
.container {
  width: 1140px;
  margin: 0 auto;
  min-height: 100vh;
}
</style>